'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  domain: '',
  menuToggle: {
    label: 'MENU'
  },
  logo: {
    href: '/'
  },
  mainBtn: [{
    text: 'CONTACTO',
    link: '/contacto'
  }, {
    text: 'LOGIN',
    link: ''
  }],
  loginLink: {
    text: 'LOGIN',
    src: ''
  },
  siteLinks: [{
    title: {
      text: 'PRODUCTOS'
    },
    list: [{
      text: 'Gastos',
      src: '/gestion-de-gastos'
    }, {
      text: 'Viajes',
      src: '/reserva-de-viajes'
    }]
  }, {
    title: {
      text: 'SOBRE CONCUR'
    },
    list: [{
      text: 'Integracion de SAP',
      src: '/integracion-de-sap'
    }, {
      text: 'Por qué Concur',
      src: '/porque-concur'
    }]
  }, {
    title: {
      text: 'RECURSOS'
    },
    list: [{
      text: 'Declaracion de privacidad',
      src: '/declaracion-de-privacidad'
    }]
  }],
  supportLinks: [{
    text: 'CONTACTO',
    href: '/contacto'
  }],
  mobileAppText: {
    text: 'GET CONCUR MOBILE APP'
  }
};